export const rootDir = process.env.API_HUB_ROOT!;
export const execDir = process.env.API_HUB_EXEC_DIR!;
